<template >
  <div class="ub-navbar-container container-fluid">
    <!-- navbar -->
    <nav
      :class="checkClass(pageClass) + ' ' + checkClassShadow(pageClass) + ' ub-navbar navbar navbar-expand-lg'"
    >
      <!-- api-docs-page menu button -->
      <button
        class="navbar-btn"
        id="sidebarCollapse"
        @click="collapse"
        v-if="[
        'api-docs-page',
        'api-docs-content-page',
        'api-docs-description-page',
        'user-info',
        'sub-info',
        'payment-info',
        'download-info',
        'api-keys-info'
        ].includes(this.$route.name)"
      >
        <v-icon name="menu"></v-icon>
      </button>

      <!-- unibit logo -->
      <div class="unibit-logo">
        <img :src="logo_url" id="logo" @click="toHome()" alt="UniBit Logo" />
      </div>

      <!-- mobile navbar menu toggle -->
      <button
        :class="checkClass(pageClass)"
        class="btn d-lg-none"
        type="button"
        style="background:transparent"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
      >
        <v-icon name="more-vertical" style="height:1.5rem; width:1.5rem;"></v-icon>
      </button>

      <!-- navbar menu -->
      <NavbarMenu :page-class="checkClass(pageClass)"></NavbarMenu>
    </nav>

    <AssetSearch
      v-if="assetSearchBarWhiteList.includes(this.$route.name)"
      @selectSearchTicker="setSearchTicker($event)"
      ref="AssetSearchBar"
    ></AssetSearch>
  </div>
</template>

<script>
/**
 * @author Patrick Watrous, Chenfeng
 * @description Navigation Bar
 * @module fixed/navbar
 * @name  navbar
 */
import NavbarMenu from "@/components/fixed/navbar/navbar-menu";
import AssetSearch from "@/components/utils/asset-search.vue";
import { mapGetters } from "vuex";

export default {
  props: {
    pageClass: {
      type: String,
      default: "black-navbar"
    }
  },

  components: {
    NavbarMenu,
    AssetSearch
  },

  data() {
    return {
      navbarPageWhiteList: [
        "pricing-page",
        "faq-page",
        "advertising-page",
        "insight-company-page",
        "company-tearsheet-page",
        "company-financials-page",
        "company-insider-page",
        "company-ownership-page",
        "company-secfiling-page",
        "insight-news-page",
        "insight-opinion-page",
        "user-info",
        "sub-info",
        "payment-info",
        "download-info",
        "api-keys-info"
      ],
      assetSearchBarWhiteList: [
        "insight-company-page",
        "company-tearsheet-page",
        "company-financials-page",
        "company-insider-page",
        "company-ownership-page",
        "company-secfiling-page",
        "insight-news-page",
        "insight-opinion-page"
      ],
      navbarPageShadowList: [
        "user-info",
        "sub-info",
        "payment-info",
        "download-info",
        "api-keys-info"
      ]
    };
  },

  computed: {
    logo_url() {
      return this.navbarPageWhiteList.includes(this.pageClass)
        ? require("@/assets/imgs/logo-black.png")
        : require("@/assets/imgs/logo-white.png");
    },
    ...mapGetters(["isLogin"])
  },

  mounted() {
    // bind search bar on scroll event
    window.addEventListener("scroll", this.handleSearchBarScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleSearchBarScroll);
  },

  methods: {
    toHome() {
      this.$router.push({ name: "home-page" });
    },

    collapse() {
      $("#sidebar").toggleClass("active");
    },

    checkClass(pageName) {
      return this.navbarPageWhiteList.includes(pageName)
        ? "white-navbar"
        : "black-navbar";
    },

    checkClassShadow(pageName) {
      return this.navbarPageShadowList.includes(pageName)
        ? "navbar-shadow"
        : "";
    },

    setSearchTicker(assetInfo) {
      console.log("[navbar] insight page, search assetInfo is: ", assetInfo);
      // Step 1: set search ticker
      this.$store.commit("setAssetInfo", assetInfo);

      // Step 2: save user search
      if (this.isLogin) {
        this.$store.dispatch("addAssetSearchHistory", {
          t: assetInfo.ticker,
          ak: this.getWindowLocalStorage("apikey") || "anonymous"
        });
      }
      // go to company tearsheet page
      if (this.$route.path.split("/")[2] !== "company") {
        console.log("[navbar] insight page, to company tearsheet...");
        this.$store.commit("setCurrentCompanyDataMenuItem", "Tearsheet");
        this.$router.push("/insight/company/tearsheet");
      }
    },

    // fix asset search bar when its on top of the window
    handleSearchBarScroll() {
      let assetSearchBar = this.$refs["AssetSearchBar"];

      window.onscroll = () => {
        // scroll up
        if (document.documentElement.scrollTop < 100) {
          assetSearchBar.$el.style.position = "relative";
        }
        // scroll down
        if (document.documentElement.scrollTop > 70) {
          assetSearchBar.$el.style.position = "fixed";
          assetSearchBar.$el.style.top = 0;
        }
      };
    }
  }
};
</script>

<style lang="css" scoped>
* {
  box-sizing: border-box;
  font-family: Jura;
  font-size: 1rem;
}

.ub-navbar-container {
  padding: 0 !important;
}

.ub-navbar {
  min-height: 60px;
}

#logo {
  width: 9.625rem;
  position: relative;
  display: flex;
  cursor: pointer;
}

.black-navbar {
  background: #1b2e38;
  color: white;
}

.white-navbar {
  background: transparent;
  color: black;
}

.navbar-shadow {
  box-shadow: 0 0 11px 0 rgba(198, 192, 192, 0.5);
}

.terminal {
  background: transparent !important;
  color: white;
}

/* ---------------------------------------------------
  burger menu button styling
----------------------------------------------------- */
#sidebarCollapse {
  position: relative;
  display: initial;
  width: 2.5rem;
  height: 2.5rem;
  background-color: transparent;
  border: 2px solid white;
  border-radius: 0.5rem;
  cursor: pointer;
  z-index: 99;
}

#sidebarCollapse span {
  width: 80%;
  height: 2px;
  margin: 0 auto;
  display: block;
  color: white;
  /* background-color: white; */
  transition: all 0.2s cubic-bezier(0.81, -0.33, 0.345, 1.375);
  transition-delay: 0.2s;
}

#sidebarCollapse.active span:first-of-type {
  transform: rotate(45deg) translate(0.31rem, 0.31rem);
}
#sidebarCollapse.active span:nth-of-type(2) {
  opacity: 0;
}
#sidebarCollapse.active span:last-of-type {
  transform: rotate(-45deg) translate(0.31rem, -0.31rem);
}

#sidebarCollapse span {
  transform: none;
  opacity: 1;
  margin: 5px auto;
}

/* for safari user agent */
.navbar-btn {
  padding: 1px 7px 2px;
}

.white-navbar > .navbar-btn > .icon-menu {
  color: black;
}

.black-navbar > .navbar-btn > .icon-menu {
  color: white;
}

/* ---------------------------------------------------
  Big Mobile Screen Styling
----------------------------------------------------- */
@media (min-width: 768px) {
  #logo {
    min-width: 90px;
    margin-top: 1rem;
  }
}

/* ---------------------------------------------------
  Tablet Styling
----------------------------------------------------- */
@media (min-width: 992px) {
  #sidebarCollapse {
    display: none;
  }
}

/* ---------------------------------------------------
  Desktop Styling
----------------------------------------------------- */
@media (min-width: 1200px) {
}
</style>



// WEBPACK FOOTER //
// src/components/fixed/navbar/navbar.vue